import { ConfigClient, FetchConfigSource } from './config.js';
class HttpConfigSource extends FetchConfigSource {
    get encrypted() {
        return false;
    }
}
let resolve;
let reject;
export const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
});
const cache = new Map();
let defaultInstance;
export async function init(stageEnv, sources = "default") {
    const instance = stage(stageEnv);
    if (sources == "default") {
        instance.addSource('frontend');
    }
    else {
        instance.addSource(sources);
    }
    if (!defaultInstance) {
        setDefault(instance);
    }
    return instance.loadAsync(true);
}
export function setDefault(newDefault) {
    if (defaultInstance) {
        throw new Error('The default config instance cannot be reset after initialization.');
    }
    defaultInstance = newDefault;
    Object.assign(configNS, defaultInstance.NS);
    defaultInstance.NS = configNS;
    defaultInstance.cache.forEach((v, k) => cache.set(k, v));
    defaultInstance.cache = cache;
    defaultInstance.promise.then(resolve, reject);
    return promise;
}
export function stage(_stage) {
    return new ConfigClient(_stage, HttpConfigSource);
}
export async function loadAsync(force = false) {
    return defaultInstance.loadAsync(force);
}
export function loadConfigs(force = false) {
    return defaultInstance.loadConfigs(force);
}
const configNS = { init, promise, stage, loadConfigs, setDefault };
export default configNS;
//# sourceMappingURL=web.js.map